import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Drag",
  "use": "Drag-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Drag\"><path d=\"M597.333 597.333a42.667 42.667 0 0 1 0 85.334H426.667a42.667 42.667 0 0 1 0-85.334h170.666zm128-128a42.667 42.667 0 0 1 0 85.334H298.667a42.667 42.667 0 0 1 0-85.334h426.666zm-128-128a42.667 42.667 0 0 1 0 85.334H426.667a42.667 42.667 0 1 1 0-85.334h170.666z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol